var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"FigureStat"},[_c('div',{staticClass:"FigureStat__stat"},[_vm._v(_vm._s(_vm.stat))]),_c('figcaption',{staticClass:"FigureStat__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }